<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row">
                <div class="col-sm-6" v-if="summary">
                  <div >
                    <div>
                      {{ helper.trans('labels.walletBalance') }}: <strong>{{numberFormatter.formatMoney(summary?.wallets)}}</strong>
                    </div>
                    <div>
                      {{ helper.trans('labels.accountBalance') }}: <strong>{{numberFormatter.formatMoney(summary?.accounts)}}</strong>
                    </div>
                    <div>
                      {{ helper.trans('labels.correctionSum') }}: <strong>{{numberFormatter.formatMoney(summary?.correction)}}</strong>
                    </div>
                    <div>
                      {{ helper.trans('labels.diffSum') }}: <strong>{{numberFormatter.formatMoney(summary?.diff)}}</strong>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6" v-if="!energyCheck && (feeeIOData || tronenergyData)">
                  <div v-if="tronenergyData">
                    <div>
                      TronEnergy balance: <strong>{{tronenergyData?.value / 1000000}} TRX</strong>
                    </div>

                  </div>
                  <div v-if="feeeIOData">
                    <div>
                      FeeeIO balance: <strong>{{feeeIOData?.data?.trx_money}} TRX</strong>
                    </div>
                    <div>
                      FeeeIO top up address: <strong>{{feeeIOData?.data?.recharge_address}}</strong> <copy-button :value="feeeIOData?.data?.recharge_address"></copy-button>
                    </div>
                    <div>
                      FeeeIO only from: <strong>{{feeeIOData?.data?.trx_address}}</strong>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>

          <div  class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row">
                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm" :placeholder="helper.trans('labels.address.tron')" v-model="requestDTO.address">
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col-sm-12">
            <div class="card card-body">
              <div class="overflow-auto">
                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th></th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.address.tron') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.owner') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.account') }}</th>
                    <th class="text-capitalize-first">TRX</th>
                    <th class="text-capitalize-first">USDT</th>
                    <th>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="wallet in wallets.items" :key="wallet.id" class="">
                    <td>{{wallet.id}}</td>
                    <td>
                      <i v-b-tooltip.hover :title="helper.trans('labels.wallet_not_activated')" v-if="walletsInfo[wallet.address] && !walletsInfo[wallet.address]?.isActivated" class="fa fa-warning text-warning me-2"></i>
                      <i v-if="wallet.type === WalletType.COLD" class="me-2 fa-solid fa-temperature-low text-primary" v-b-tooltip.hover :title="helper.trans('labels.cold_wallet')"></i>
                      <span>{{ wallet.address }}</span> <copy-button :value="wallet.address"></copy-button>
                      <a :href="`https://tronscan.org/#/address/${wallet.address}`" class="ms-2" target="_blank"><i class="fa fa-external-link"></i></a>
                    </td>
                    <td>
                      <small v-if="wallet.accountOwner"
                             :class="{'bg-secondary': wallet.accountOwner.type === 'store' ,'bg-danger': wallet.accountOwner.type === 'system', 'bg-primary': wallet.accountOwner.type === 'trader', 'bg-info': wallet.accountOwner.type === UserRole.TRADER_TEAM_LEAD || wallet.accountOwner.type === UserRole.REFERRAL}"
                             class="badge"
                             v-b-tooltip.hover
                             :title="helper.trans(`account_owner.${wallet.accountOwner?.type}`)">
                        {{ wallet.accountOwner?.name}}
                      </small>
                    </td>
                    <td>
                      <div v-if="wallet.accountId">
                        <span  v-b-tooltip.hover :title="wallet.accountId">{{ wallet.accountId?.substring(0, 8) }}...</span> <copy-button :value="wallet.accountId"></copy-button>
                      </div>
                      <span v-else>n/a</span>
                    </td>
                    <td>
                      {{ walletsInfo[wallet.address] ? numberFormatter.formatNumber(walletsInfo[wallet.address].trx) : 'n/a' }}
                    </td>
                    <td>
                      {{ walletsInfo[wallet.address] ? numberFormatter.formatNumber(walletsInfo[wallet.address].usdt) : 'n/a' }}
                    </td>
                    <td>
                      <i v-if="walletsInfo[wallet.address]" @click.prevent="loadWalletBalance(wallet)" style="cursor: pointer" class="fa-solid fa-rotate"></i>
                      <i v-else class="fa-solid fa-spinner fa-spin-pulse"></i>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="wallets.totalCount > wallets.items.length"
                  v-model="page"
                  :total-rows="wallets.totalCount"
                  :per-page="wallets.limit"
                  :limit="20"
                  @update:modelValue="loadWallets()"
                  prev-text="Back"
                  next-text="Next"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import WalletDTO from "@/models/WalletDTO";
import TronWeb from "tronweb";
import MoneyDTO from "@/models/MoneyDTO";
import {UserRole} from "@/models/enum/UserRole";
import {WalletType} from "@/models/enum/WalletType";
import WalletInfoDTO from "@/models/WalletInfoDTO";
import WalletsRequestDTO from "@/models/request/WalletsRequestDTO";

const api = new APIClient();
const notification = useNotification()

const tronWeb = new TronWeb({
    fullHost: 'https://api.trongrid.io',
    headers: {"TRON-PRO-API-KEY": '4c1ecf85-321b-4282-b5ab-9911efc7e0ce'},
  }
)

const SUN_MUL = 1000000;
const TRC20_USDT = 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t';


export default defineComponent({
  components: {
    LoaderWrapper,
    ConfirmModal,
    CopyButton,
    BPagination,
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)


    const state = reactive({
      page: 1,
      summary: null as any|null,
      feeeIOData: null as any|null,
      tronenergyData: null as any|null,
      energyCheck: process.env.VUE_APP_HIDE_ENERGY_BALANCE === undefined ? 0 : Number(process.env.VUE_APP_HIDE_ENERGY_BALANCE),
      wallets: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<WalletDTO>,
      requestDTO: {
        address: null,
        accountIds: null
      } as WalletsRequestDTO,
      walletsInfo: {} as WalletInfoDTO[] | any
    });

    const sleep = (ms: number) => {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    }

    const loadSummary = async () => {
      state.summary = await api.walletsSummary();
    }

    const loadFeeIO = async () => {
      const data = await api.energyData();
      state.feeeIOData = data.feee
      state.tronenergyData = data.tronenergy
    }

    const loadWallets = async () => {
      console.log(state.requestDTO)
      loader.value?.show()
      state.wallets.offset = state.wallets.limit * (state.page - 1)
      state.wallets = await api.wallets(state.wallets, state.requestDTO);
      loader.value?.hide()

      for (const wallet of state.wallets.items) {
        await loadWalletBalance(wallet);
        await sleep(300)
      }

    }

    const loadWalletBalance = async (wallet: WalletDTO) => {
      tronWeb.setAddress(wallet.address)

      state.walletsInfo[wallet.address] = null;

      const balanceOfResult = await tronWeb.transactionBuilder.triggerConstantContract(
        TRC20_USDT,
        'balanceOf(address)',
        {},
        [{type: 'address', value: wallet.address}],
        wallet.address
      )

      const balanceUSDT = parseInt(balanceOfResult.constant_result[0], 16) / SUN_MUL
      const account = await tronWeb.trx.getAccount(wallet.address);
      const balanceTRX = (account.balance ?? 0) / SUN_MUL

      state.walletsInfo[wallet.address] = {
        isActivated: !!account.address,
        trx: {amount: balanceTRX.toString(), currency: 'TRX', subunit: 8} as MoneyDTO,
        usdt: {amount: balanceUSDT.toString(), currency: 'USDT', subunit: 8} as MoneyDTO
      } as WalletInfoDTO
    }

    const applyFilters = async () => {
      state.page = 1;
      loadWallets()
    }

    const clearFilters = async () => {
      state.page = 1;
      state.requestDTO = {
        address: null,
        accountIds: null
      }
      loadWallets()
    }

    onMounted(() => {
      loadWallets()
      loadSummary();
      if (!state.energyCheck) {
        loadFeeIO();
      }
    });

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      loader,
      dateHelper,
      numberFormatter,
      confirmModal,
      loadWallets,
      helper,
      UserRole,
      WalletType,
      loadWalletBalance,
      applyFilters,
      clearFilters
    }
  }
})
</script>
